import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Edit({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Edit.Outline {...props} /> : <Edit.Solid {...props} />;
}

Edit.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7708 2.91737C16.9947 1.69486 18.9781 1.69486 20.2019 2.91737L21.4192 4.13466C22.6429 5.35839 22.6434 7.34349 21.4189 8.5666L13.9102 16.0753C13.3627 16.6228 12.62 16.931 11.8449 16.931H8.09888C7.89673 16.931 7.70315 16.8494 7.562 16.7047C7.42085 16.56 7.34408 16.3644 7.34911 16.1623L7.44311 12.3823C7.46195 11.6342 7.7674 10.9208 8.29755 10.3907L15.7708 2.91737ZM19.1418 3.9786C18.5037 3.34112 17.4691 3.34112 16.8309 3.9786L16.2165 4.59306L19.7438 8.1204L20.3585 7.50566C20.9961 6.86877 20.9968 5.83358 20.3585 5.19532L19.1418 3.9786ZM18.6831 9.18106L15.1558 5.65372L9.35821 11.4513C9.10041 11.7091 8.95187 12.0559 8.94265 12.4196L8.86776 15.431H11.8449C12.2217 15.431 12.583 15.2812 12.8495 15.0147L18.6831 9.18106Z"
          fill="currentColor"
        />
        <path
          d="M3.54999 3.75144C4.57274 2.65417 6.02998 2.03906 7.75324 2.03906H11.4922C11.9065 2.03906 12.2422 2.37485 12.2422 2.78906C12.2422 3.20328 11.9065 3.53906 11.4922 3.53906H7.75324C6.40151 3.53906 5.35725 4.01246 4.64725 4.77419C3.9318 5.54176 3.50024 6.66275 3.50024 8.04806V16.3621C3.50024 17.7483 3.9301 18.8692 4.64421 19.6363C5.35267 20.3974 6.39653 20.8711 7.75324 20.8711H16.5772C17.9345 20.8711 18.9786 20.3973 19.6872 19.6363C20.4014 18.8691 20.8312 17.7483 20.8312 16.3621V12.3341C20.8312 11.9198 21.167 11.5841 21.5812 11.5841C21.9955 11.5841 22.3312 11.9198 22.3312 12.3341V16.3621C22.3312 18.0578 21.8016 19.5665 20.785 20.6584C19.7629 21.7563 18.305 22.3711 16.5772 22.3711H7.75324C6.02596 22.3711 4.56832 21.7563 3.54628 20.6583C2.52989 19.5665 2.00024 18.0578 2.00024 16.3621V8.04806C2.00024 6.35137 2.53269 4.84286 3.54999 3.75144Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Edit.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7708 2.91737C16.9947 1.69486 18.9781 1.69486 20.2019 2.91737L21.4192 4.13466C22.6429 5.35839 22.6434 7.34349 21.4189 8.5666L13.9102 16.0753C13.3627 16.6228 12.62 16.931 11.8449 16.931H8.09888C7.89673 16.931 7.70315 16.8494 7.562 16.7047C7.42085 16.56 7.34408 16.3644 7.34911 16.1623L7.44311 12.3823C7.46195 11.6342 7.7674 10.9208 8.29755 10.3907L15.7708 2.91737ZM19.1418 3.9786C18.5037 3.34112 17.4691 3.34112 16.8309 3.9786L16.2165 4.59306L19.7438 8.1204L20.3585 7.50566C20.9961 6.86877 20.9968 5.83358 20.3585 5.19532L19.1418 3.9786ZM18.6831 9.18106L15.1558 5.65372L9.35821 11.4513C9.10041 11.7091 8.95187 12.0559 8.94265 12.4196L8.86776 15.431H11.8449C12.2217 15.431 12.583 15.2812 12.8495 15.0147L18.6831 9.18106Z"
          fill="currentColor"
        />
        <path
          d="M3.54999 3.75144C4.57274 2.65417 6.02998 2.03906 7.75324 2.03906H11.4922C11.9065 2.03906 12.2422 2.37485 12.2422 2.78906C12.2422 3.20328 11.9065 3.53906 11.4922 3.53906H7.75324C6.40151 3.53906 5.35725 4.01246 4.64725 4.77419C3.9318 5.54176 3.50024 6.66275 3.50024 8.04806V16.3621C3.50024 17.7483 3.9301 18.8692 4.64421 19.6363C5.35267 20.3974 6.39653 20.8711 7.75324 20.8711H16.5772C17.9345 20.8711 18.9786 20.3973 19.6872 19.6363C20.4014 18.8691 20.8312 17.7483 20.8312 16.3621V12.3341C20.8312 11.9198 21.167 11.5841 21.5812 11.5841C21.9955 11.5841 22.3312 11.9198 22.3312 12.3341V16.3621C22.3312 18.0578 21.8016 19.5665 20.785 20.6584C19.7629 21.7563 18.305 22.3711 16.5772 22.3711H7.75324C6.02596 22.3711 4.56832 21.7563 3.54628 20.6583C2.52989 19.5665 2.00024 18.0578 2.00024 16.3621V8.04806C2.00024 6.35137 2.53269 4.84286 3.54999 3.75144Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
